import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal, Tab, Tabs } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../Turnero.css';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faSave, faCheck, faPlus, faEdit, faTrash, faCalendarAlt, faClock, faUserSecret } from '@fortawesome/free-solid-svg-icons';

/**
 * SpecialistABM - CRUD for Specialists (Especialistas) and their availability
 */
const SpecialistABM = ({ ipserv, branch_id }) => {
    const [loading, setLoading] = useState(false);
    const [specialists, setSpecialists] = useState([]);
    const [specialties, setSpecialties] = useState([]);
    const [staffUsers, setStaffUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [key, setKey] = useState('datos');

    const [formData, setFormData] = useState({
        EspecialistaNombre: '',
        EspecialistaApellido: '',
        EspecialistaEmail: '',
        EspecialistaTelefono: '',
        StaffId: '',
        EspecialistaModalidad: 'WEB',
        EspecialistaSlotDuracion: 20,
        especialidades: []
    });

    const [availability, setAvailability] = useState([]);

    const loadData = () => {
        if (!branch_id) return;
        setLoading(true);
        // Specialists
        request.Get(ipserv + 'turnero/specialists', { sucursalId: branch_id }, r => {
            if (r.success) setSpecialists(r.data || []);
        });
        // Specialties
        request.Get(ipserv + 'turnero/specialties', { sucursalId: branch_id }, r => {
            if (r.success) setSpecialties(r.data || []);
        });
        // Staff Users
        request.Get(ipserv + 'getTurneroUsers', { sucursalId: branch_id }, r => {
            if (r.success) setStaffUsers(r.data || []);
            setLoading(false);
        });
    };

    useEffect(() => {
        loadData();
    }, [branch_id]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setKey('datos');
        setFormData(item ? {
            ...item,
            especialidades: item.especialidades || []
        } : {
            EspecialistaNombre: '',
            EspecialistaApellido: '',
            EspecialistaEmail: '',
            EspecialistaTelefono: '',
            StaffId: '',
            EspecialistaModalidad: 'WEB',
            EspecialistaSlotDuracion: 20,
            especialidades: []
        });

        if (item) {
            request.Get(ipserv + 'turnero/availability', { especialistaId: item.EspecialistaId }, r => {
                if (r.success) setAvailability(r.data || []);
            });
        } else {
            setAvailability([]);
        }

        setShowModal(true);
    };

    const handleSave = (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        request.Post(ipserv + 'turnero/saveSpecialist', {
            ...formData,
            EspecialistaId: currentItem?.EspecialistaId,
            SucursalId: branch_id
        }, r => {
            if (r.success) {
                // If it's a new specialist, we now have the ID to save availability if needed
                const specialistId = currentItem?.EspecialistaId || r.EspecialistaId;
                
                // Save Availability
                request.Post(ipserv + 'turnero/saveAvailability', {
                    especialistaId: specialistId,
                    slots: availability
                }, resAv => {
                    if (resAv.success) {
                        Notify({ type: 'success', text: 'Especialista y agenda guardados' });
                        setShowModal(false);
                        loadData();
                    }
                });
            } else {
                Notify({ type: 'fail', text: r.msg || 'Error al guardar' });
            }
            setLoading(false);
        });
    };

    const addAvailabilitySlot = () => {
        setAvailability([...availability, { DiaSemana: 1, HoraInicio: '09:00:00', HoraFin: '13:00:00' }]);
    };

    const removeAvailabilitySlot = (index) => {
        const updated = [...availability];
        updated.splice(index, 1);
        setAvailability(updated);
    };

    const updateSlot = (index, field, value) => {
        const updated = [...availability];
        updated[index][field] = value;
        setAvailability(updated);
    };

    const days = [
        { id: 1, name: 'Lunes' },
        { id: 2, name: 'Martes' },
        { id: 3, name: 'Miércoles' },
        { id: 4, name: 'Jueves' },
        { id: 5, name: 'Viernes' },
        { id: 6, name: 'Sábado' },
        { id: 7, name: 'Domingo' }
    ];

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Especialistas</h2>
                    <p className="text-muted small">Gestiona los profesionales y sus horarios de atención.</p>
                </div>
                <button
                    className="auth-btn-primary"
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
                    onClick={() => handleOpenModal()}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nuevo Especialista
                </button>
            </div>

            <div className="turnero-card p-0 overflow-hidden">
                <table className="table table-dark table-hover m-0">
                    <thead className="bg-glass">
                        <tr>
                            <th className="border-0 p-3">Especialista</th>
                            <th className="border-0 p-3">Contacto</th>
                            <th className="border-0 p-3">Modalidad</th>
                            <th className="border-0 p-3">Slot (min)</th>
                            <th className="border-0 p-3 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && specialists.length === 0 ? (
                            <tr><td colSpan="5" className="text-center p-5"><Spinner animation="border" variant="primary" /></td></tr>
                        ) : specialists.length === 0 ? (
                            <tr><td colSpan="5" className="text-center p-5 text-muted">No hay especialistas cargados</td></tr>
                        ) : (
                            specialists.map(s => (
                                <tr key={s.EspecialistaId} className="animate-in">
                                    <td className="p-3">
                                        <div className="font-weight-bold">{s.EspecialistaApellido}, {s.EspecialistaNombre}</div>
                                        <div className="small text-muted">{s.SucursalNombre}</div>
                                    </td>
                                    <td className="p-3 small">
                                        <div>{s.EspecialistaEmail}</div>
                                        <div>{s.EspecialistaTelefono}</div>
                                    </td>
                                    <td className="p-3">
                                        <span className={`turnero-badge ${s.EspecialistaModalidad === 'WEB' ? 'bg-primary' : 'bg-info'}`}>
                                            {s.EspecialistaModalidad}
                                        </span>
                                    </td>
                                    <td className="p-3">{s.EspecialistaSlotDuracion}m</td>
                                    <td className="p-3 text-center">
                                        <button className="btn btn-sm btn-outline-info mr-2" onClick={() => handleOpenModal(s)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className="btn btn-sm btn-outline-danger">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" contentClassName="turnero-card border-0">
                <Modal.Body className="p-0">
                    <div className="p-4 bg-glass border-bottom d-flex align-items-center">
                        <FontAwesomeIcon icon={faUserTie} className="mr-3 text-primary" size="2x" />
                        <div>
                            <h4 className="mb-0 font-weight-bold text-white">{currentItem ? 'Editar Especialista' : 'Nuevo Especialista'}</h4>
                            <p className="text-muted small mb-0">Configura el perfil, áreas y agenda de atención.</p>
                        </div>
                    </div>

                    <Tabs id="specialist-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="turnero-tabs px-4 pt-3">
                        <Tab eventKey="datos" title="Datos Generales">
                            <div className="p-4 text-white">
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <label className="small text-muted mb-1">Nombre</label>
                                        <input type="text" className="turnero-input" value={formData.EspecialistaNombre} onChange={e => setFormData({ ...formData, EspecialistaNombre: e.target.value.toUpperCase() })} required />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <label className="small text-muted mb-1">Apellido</label>
                                        <input type="text" className="turnero-input" value={formData.EspecialistaApellido} onChange={e => setFormData({ ...formData, EspecialistaApellido: e.target.value.toUpperCase() })} required />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <label className="small text-muted mb-1">Email</label>
                                        <input type="email" className="turnero-input" value={formData.EspecialistaEmail} onChange={e => setFormData({ ...formData, EspecialistaEmail: e.target.value })} />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <label className="small text-muted mb-1">Teléfono</label>
                                        <input type="text" className="turnero-input" value={formData.EspecialistaTelefono} onChange={e => setFormData({ ...formData, EspecialistaTelefono: e.target.value })} />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <label className="small text-muted mb-1">Usuario Staff Asociado (Opcional)</label>
                                        <select className="turnero-input" value={formData.StaffId} onChange={e => setFormData({ ...formData, StaffId: e.target.value })}>
                                            <option value="">Seleccione usuario...</option>
                                            {staffUsers.map(u => <option key={u.UsrId} value={u.UsrId}>{u.UsrApellido}, {u.UsrNombre} ({u.UsrDni})</option>)}
                                        </select>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <label className="small text-muted mb-1">Modalidad</label>
                                        <select className="turnero-input" value={formData.EspecialistaModalidad} onChange={e => setFormData({ ...formData, EspecialistaModalidad: e.target.value })}>
                                            <option value="WEB">WEB</option>
                                            <option value="PRESENCIAL">PRESENCIAL</option>
                                        </select>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <label className="small text-muted mb-1">Duración Slot (min)</label>
                                        <input type="number" className="turnero-input" value={formData.EspecialistaSlotDuracion} onChange={e => setFormData({ ...formData, EspecialistaSlotDuracion: e.target.value })} />
                                    </Col>
                                </Row>
                            </div>
                        </Tab>

                        <Tab eventKey="especialidades" title="Especialidades">
                            <div className="p-4 text-white">
                                <p className="small text-muted mb-3">Selecciona las áreas en las que este profesional atiende:</p>
                                <div className="turnero-input p-3" style={{ height: '200px', overflowY: 'auto' }}>
                                    {specialties.length === 0 ? (
                                        <div className="text-muted text-center p-4">No hay especialidades cargadas en esta sucursal.</div>
                                    ) : (
                                        specialties.map(spec => (
                                            <div key={spec.EspecialidadId} className="custom-control custom-checkbox mb-2">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={`spec-${spec.EspecialidadId}`}
                                                    checked={formData.especialidades.includes(spec.EspecialidadId)}
                                                    onChange={e => {
                                                        const id = spec.EspecialidadId;
                                                        const current = [...formData.especialidades];
                                                        if (e.target.checked) {
                                                            if (!current.includes(id)) current.push(id);
                                                        } else {
                                                            const idx = current.indexOf(id);
                                                            if (idx > -1) current.splice(idx, 1);
                                                        }
                                                        setFormData({ ...formData, especialidades: current });
                                                    }}
                                                />
                                                <label className="custom-control-label text-white ml-2 clickable" htmlFor={`spec-${spec.EspecialidadId}`}>
                                                    {spec.EspecialidadNombre} <span className="text-muted small">({spec.TipoNombre})</span>
                                                </label>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </Tab>

                        <Tab eventKey="agenda" title="Agenda / Horarios">
                            <div className="p-4 text-white">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <p className="small text-muted mb-0">Define los bloques horarios de atención semanal:</p>
                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={addAvailabilitySlot}>
                                        <FontAwesomeIcon icon={faPlus} className="mr-1" /> Añadir Bloque
                                    </button>
                                </div>

                                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                    {availability.length === 0 ? (
                                        <div className="text-center p-4 bg-glass-dark border-radius-12 text-muted small">Sin horarios configurados.</div>
                                    ) : (
                                        availability.map((slot, index) => (
                                            <Row key={index} className="mb-2 align-items-center animate-in bg-glass-dark p-2 mx-0 border-radius-12">
                                                <Col md={4}>
                                                    <select className="turnero-input py-1" value={slot.DiaSemana} onChange={e => updateSlot(index, 'DiaSemana', parseInt(e.target.value))}>
                                                        {days.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                                                    </select>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="d-flex align-items-center">
                                                        <FontAwesomeIcon icon={faClock} className="mr-2 text-muted" style={{ fontSize: '0.8rem' }} />
                                                        <input type="time" className="turnero-input py-1" value={slot.HoraInicio} onChange={e => updateSlot(index, 'HoraInicio', e.target.value)} />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="d-flex align-items-center">
                                                        <FontAwesomeIcon icon={faClock} className="mr-2 text-muted" style={{ fontSize: '0.8rem' }} />
                                                        <input type="time" className="turnero-input py-1" value={slot.HoraFin} onChange={e => updateSlot(index, 'HoraFin', e.target.value)} />
                                                    </div>
                                                </Col>
                                                <Col md={2} className="text-right">
                                                    <button type="button" className="btn btn-link text-danger p-0" onClick={() => removeAvailabilitySlot(index)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        ))
                                    )}
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer className="border-0 px-4 pb-4 bg-glass">
                    <button type="button" className="btn btn-link text-muted" onClick={() => setShowModal(false)}>Cancelar</button>
                    <button type="button" className="turnero-btn turnero-btn-primary px-5" onClick={handleSave} disabled={loading}>
                        {loading ? <Spinner size="sm" animation="border" /> : (
                            <><FontAwesomeIcon icon={faSave} className="mr-2" /> Guardar Especialista</>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SpecialistABM;
